"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _antd = require("antd");

var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));

var _CmsLayout = _interopRequireDefault(require("../components/CmsLayout"));

var _ListItem = _interopRequireDefault(require("../components/ListItem"));

var _UserForm = _interopRequireDefault(require("../components/UserForm"));

var _actions = require("../actions");

var _store = require("../store");

var _templateObject, _templateObject2;

var Users = function Users() {
  var _ref4 = (0, _store.useStore)(),
      _ref5 = _slicedToArray(_ref4, 2),
      _ref5$ = _ref5[0],
      config = _ref5$.config,
      _ref5$$cmsState = _ref5$.cmsState,
      siteID = _ref5$$cmsState.siteID,
      sites = _ref5$$cmsState.sites,
      authUser = _ref5$.authState.authUser,
      dispatch = _ref5[1];

  var _sites$siteID$users = sites[siteID].users,
      items = _sites$siteID$users.items,
      page = _sites$siteID$users.page;
  (0, _react.useEffect)(function () {
    loadUsers(page || 0);
  }, []);

  var loadUsers = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(page) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(page > -1)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _actions.userActions.getUsers({
                siteID: siteID,
                page: page,
                limit: 10
              }, dispatch, config);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function loadUsers(_x) {
      return _ref6.apply(this, arguments);
    };
  }();

  var handleLoadMore = function handleLoadMore() {
    return page && loadUsers(page);
  };

  var handleOpenDialog = function handleOpenDialog() {
    var user = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return dispatch({
      type: 'SET_DIALOG',
      payload: {
        open: true,
        title: "Add",
        component: /*#__PURE__*/_react.default.createElement(_UserForm.default, (0, _extends2.default)({
          onUpdate: handleUpdate,
          onAdd: handleAdd
        }, user))
      }
    });
  };

  var handleAdd = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref) {
      var email, role;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              email = _ref.email, role = _ref.role;
              _context2.next = 3;
              return _actions.userActions.addUser({
                siteID: siteID,
                email: email,
                role: role
              }, dispatch, config);

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleAdd(_x2) {
      return _ref7.apply(this, arguments);
    };
  }();

  var handleUpdate = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref2) {
      var id, role;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              id = _ref2.id, role = _ref2.role;
              _context3.next = 3;
              return _actions.userActions.updateUser({
                siteID: siteID,
                id: id,
                role: role
              }, dispatch, config);

            case 3:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleUpdate(_x3) {
      return _ref8.apply(this, arguments);
    };
  }();

  var handleDelete = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref3) {
      var id;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              id = _ref3.id;
              _context4.next = 3;
              return _actions.userActions.deleteUser({
                siteID: siteID,
                id: id
              }, dispatch, config);

            case 3:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleDelete(_x4) {
      return _ref9.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement(_CmsLayout.default, {
    pageTitle: "Users"
  }, /*#__PURE__*/_react.default.createElement(_antd.PageHeader, null, /*#__PURE__*/_react.default.createElement(_antd.Button, {
    children: "Add",
    onClick: handleOpenDialog,
    type: "primary"
  })), /*#__PURE__*/_react.default.createElement(StyledListItem, {
    title: authUser === null || authUser === void 0 ? void 0 : authUser.email,
    subtitle: authUser === null || authUser === void 0 ? void 0 : authUser.role
  }), /*#__PURE__*/_react.default.createElement(_reactInfiniteScroller.default, {
    pageStart: 0,
    loadMore: handleLoadMore,
    hasMore: page > -1,
    loader: /*#__PURE__*/_react.default.createElement(LoadingContainer, {
      key: 0
    }, /*#__PURE__*/_react.default.createElement(_antd.Spin, {
      size: "large"
    }))
  }, items && items.map(function (o) {
    var actions = [/*#__PURE__*/_react.default.createElement(_antd.Popconfirm, {
      key: "delete",
      title: "Are you sure?",
      onConfirm: function onConfirm() {
        return handleDelete(o);
      },
      okText: "Yes",
      cancelText: "No"
    }, /*#__PURE__*/_react.default.createElement(_antd.Button, {
      size: "small",
      children: "Delete",
      danger: true
    })), /*#__PURE__*/_react.default.createElement(_antd.Button, {
      key: "edit",
      size: "small",
      onClick: function onClick() {
        return handleOpenDialog(o);
      }
    }, "Edit")];
    return /*#__PURE__*/_react.default.createElement(StyledListItem, {
      key: o.id,
      title: o.email,
      subtitle: o.role,
      actions: actions
    });
  })));
};

var LoadingContainer = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  justify-content: center;\n"])));

var StyledListItem = (0, _styledComponents.default)(_ListItem.default)(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["\n  margin-top: 20px;\n  margin-bottom: 20px;\n"])));
var _default = Users;
exports.default = _default;